import type {
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from 'react';

/**
 * The label-plus-control pair every form in this app repeats. `id` is required
 * rather than optional because it is what ties the two together — a labelled
 * control with no id is the bug this exists to prevent.
 */
export function Field({
  id,
  label,
  className = 'field-input',
  ...input
}: { id: string; label: string } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div>
      <label htmlFor={id} className="field-label">
        {label}
      </label>
      <input id={id} className={className} {...input} />
    </div>
  );
}

export function SelectField({
  id,
  label,
  className = 'field-select',
  children,
  ...select
}: {
  id: string;
  label: string;
  children: ReactNode;
} & SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div>
      <label htmlFor={id} className="field-label">
        {label}
      </label>
      <select id={id} className={className} {...select}>
        {children}
      </select>
    </div>
  );
}

/** `Field` for several lines of free text, such as notes. */
export function TextareaField({
  id,
  label,
  className = 'field-input',
  rows = 4,
  ...textarea
}: {
  id: string;
  label: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <div>
      <label htmlFor={id} className="field-label">
        {label}
      </label>
      <textarea id={id} className={className} rows={rows} {...textarea} />
    </div>
  );
}
